import general from "./general";
import step1 from "./step1";
import service_centers from "./service-centers";
import accessibility_declaration from "./accessibility-declaration";
import user_manual from "./user-manual";
import payment from "./payment";
import payment_finish from "./payment_finish";
import cookie_confirm from "./cookie_confirm";
import privacy_policy from "./privacy_policy";

export default {
	...general,
	...step1,
	...service_centers,
	...accessibility_declaration,
	...user_manual,
	...payment,
	...payment_finish,
	...cookie_confirm,
	...privacy_policy
}